/**
 * GSAP + ScrollTrigger: fade-up, blur, list, parallax 이미지, clip, scale
 */
export class HomeScrollAnimations {
    static init(): void {
        const gsap = window.gsap;
        const ST = window.ScrollTrigger;
        if (!gsap || !ST) return;

        document.querySelectorAll(".fade-up").forEach((item) => {
            gsap.fromTo(
                item,
                { opacity: 0, y: 40 },
                {
                    opacity: 1,
                    y: 0,
                    duration: 0.9,
                    clearProps: "y",
                    scrollTrigger: {
                        trigger: item,
                        start: "top 80%",
                        end: "bottom 20%",
                    },
                },
            );
        });

        document.querySelectorAll(".blur-js").forEach((item) => {
            gsap.fromTo(
                item,
                { opacity: 0, filter: "blur(16px)", y: 40 },
                {
                    opacity: 1,
                    filter: "blur(0px)",
                    duration: 1.2,
                    ease: "power2.out",
                    y: 0,
                    clearProps: "y",
                    scrollTrigger: {
                        trigger: item,
                        start: "top 80%",
                        end: "bottom 20%",
                    },
                },
            );
        });

        document.querySelectorAll(".list-js").forEach((list) => {
            const mainItems = list.querySelectorAll(":scope > li");
            gsap.fromTo(
                mainItems,
                { opacity: 0, y: 50 },
                {
                    opacity: 1,
                    y: 0,
                    duration: 0.9,
                    stagger: 0.3,
                    clearProps: "y",
                    scrollTrigger: {
                        trigger: list,
                        start: "top 80%",
                        end: "bottom 20%",
                    },
                },
            );
        });

        const images = document.querySelectorAll(".move-img img");
        if (images.length > 0) {
            gsap.set(images, { scale: 1.1 });
            images.forEach((image) => {
                gsap.fromTo(
                    image,
                    { yPercent: -15 },
                    {
                        yPercent: 0,
                        scrollTrigger: {
                            trigger: image,
                            start: "top-=10% bottom",
                            end: "bottom+=20% top",
                            scrub: 1,
                        },
                    },
                );
            });
        }

        document.querySelectorAll(".clip-down-up").forEach((img) => {
            gsap.fromTo(
                img,
                { clipPath: "inset(0 0 100% 0)" },
                {
                    clipPath: "inset(0 0 0% 0)",
                    duration: 1.2,
                    ease: "power2.out",
                    scrollTrigger: { trigger: img, start: "top 80%" },
                },
            );
        });

        document.querySelectorAll(".scale-img img").forEach((img) => {
            gsap.fromTo(
                img,
                { scale: 1.3 },
                {
                    scale: 1.1,
                    duration: 1.2,
                    scrollTrigger: { trigger: img, start: "top 80%" },
                },
            );
        });
    }
}
